import { render } from "./Brands.vue?vue&type=template&id=562a4680"
import script from "./Brands.vue?vue&type=script&lang=js"
export * from "./Brands.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3562841475/src/github.com/abstraktgt/anysubscription/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__